<template>
    <div>
        <strong>
            {{ data?.name }}
        </strong>
        <div class="flex flex-row gap-1 my-4">
            <Icon :class="data.stars >= 1 ? 'text-blue' : 'text-gray-300'" class="fill-current" type="Star" viewBox="0 0 576 512" width="15" height="15" />
            <Icon :class="data.stars >= 2 ? 'text-blue' : 'text-gray-300'" class="fill-current" type="Star" viewBox="0 0 576 512" width="15" height="15" />
            <Icon :class="data.stars >= 3 ? 'text-blue' : 'text-gray-300'" class="fill-current" type="Star" viewBox="0 0 576 512" width="15" height="15" />
            <Icon :class="data.stars >= 4 ? 'text-blue' : 'text-gray-300'" class="fill-current" type="Star" viewBox="0 0 576 512" width="15" height="15" />
            <Icon :class="data.stars >= 5 ? 'text-blue' : 'text-gray-300'" class="fill-current" type="Star" viewBox="0 0 576 512" width="15" height="15" />
        </div>
        <hr class="border-gray-300 my-4" />
        <div :class="expanded ? 'line-clamp-none' : lineClamp" ref="text" v-html="$t(data?.content)"></div>
        <span v-if="!expanded && lineCount >= 5" @click="expanded = true" class="text-blue cursor-pointer mt-1">
            {{ $t('read_more') }}
        </span>
        <span v-if="expanded && lineCount >= 5" @click="expanded = false" class="text-blue cursor-pointer mt-1">
            {{ $t('show_less') }}
        </span>
    </div>
</template>

<script>
export default {
    props: ['data', 'slideChanging'],
    data: () => ({
        expanded: false,
        lineCount: 0,
        lineClamp: null
    }),
    mounted() {
        this.$nextTick(() => {
            this.lineCount = this.$countLines(this.$refs.text);
            this.$refs.text.classList.add('line-clamp-3');
            this.lineClamp = 'line-clamp-3';
        });
    },
    watch: {
        slideChanging() {
            this.expanded = false;
        }
    }
};
</script>
